// extracted by mini-css-extract-plugin
module.exports = {"label":"e_D7","disc":"e_E7","glyph":"e_F7","labelButton":"e_G7","tip":"e_H7","labelOpen":"e_I7"};